import { mapActions } from "vuex";
import brokerDashboard from "./../../components/PartnerBrokerDashboard.vue"
import brokerLeads from "./../../components/PartnerBrokerLeads.vue"
import brokerPromoCode from "./../../components/PartnerBrokerPromoCode.vue"
import { GET_BROKER_ALL_LEADS } from '@/store/actions.type'

export default {
    data() {
        return {

        }
    },
    components: { brokerDashboard, brokerLeads, brokerPromoCode },

    computed: {
        userDetails () {
            return this.$store.state.authentication.user
        },

         getUserState() {
            if (this.$store.state.authentication.loginState) {
                this.fetchAllLeads();
            }
        }
      },

      methods: {
        ...mapActions({
            getbrokerallleads: GET_BROKER_ALL_LEADS
          }),

        async fetchAllLeads() {
            const userType = this.getBrokerUserType(this.userDetails)

            let param = {
                "userType" : userType
            }

            await this.getbrokerallleads(param).then(data => {
                if (data != null || data.length >0) {
                    this.leadsList = data
                }
                else{
                    alert("No leads has been generated")
                }
            })
        },


        getBrokerUserType(userDetails) {
            var userType = 1
            if (userDetails.userType == 2 && userDetails.isBrokerAdminUser == 1) {
              userType = 3 // for anand rathi broker
            }
          
            return userType
        }
      }
}


// WEBPACK FOOTER //
// ./src/assets/js/PartnerBrokerAdminTabs.js